import type { SkeletonProps } from '..';
import { Skeleton } from '..';

export interface SkeletonInferredProps extends SkeletonProps {
  isLoading?: boolean;
}

export const SkeletonInferred = ({
  isLoading,
  children,
  ...rest
}: SkeletonInferredProps) => {
  if (isLoading) {
    return (
      <Skeleton role="status" aria-label="Loading..." {...rest}>
        {children}
      </Skeleton>
    );
  }

  return children;
};
